export const BootstrapSources = {
  SESSION_INIT: 'session-init',
}

export const RouteSources = {
  BACK: '__back__',
}

export const QuerySources = {
  PROFILE: 'profile',
  ADMIN_DASHBOARD: 'admin-dashboard',
  ANALYTICS_LEARNING: 'analytics-learning',
  ANALYTICS_COURSES: 'analytics-courses',
  ANALYTICS_COURSE_DETAIL: 'analytics-course-detail',
  ANALYTICS_STUDENTS: 'analytics-students',
  ANALYTICS_VIDEOS: 'analytics-videos',
  ANALYTICS_LECTURES: 'analytics-lectures',
  ANALYTICS_USERS: 'analytics-users',
  ANALYTICS_REVENUE: 'analytics-revenue',
  ADMIN_TABLE: 'admin-table',
  PUBLIC_CATALOG: 'public-catalog',
  QUIZ_QUESTION: 'quiz-question',
  ONBOARDING_OPTIONS: 'onboarding-options',
}

export const MutationSources = {
  DEFAULT: 'mutation',
  LOGIN: 'login',
  REGISTER: 'register',
  PASSWORD_RESET: 'password-reset',
  EMAIL_VERIFY: 'email-verify',
  ONBOARDING: 'onboarding',
  QUIZ_SAVE_ANSWER: 'quiz-save-answer',
  QUIZ_PAUSE: 'quiz-pause',
  QUIZ_RESUME: 'quiz-resume',
  QUIZ_FINISH: 'quiz-finish',
  QUIZ_DISCARD: 'quiz-discard',
}
